module.exports = __webpack_public_path__ + "static/media/customer.91cdacd6.svg";